import { func, arrayOf, string, shape, number } from "prop-types"
import Options from "./../Options"
import { BagPropTypes } from "../bag-prop-types"
import styled from "styled-components"

const SliderContainer = styled.div`
display:grid;
grid-template-columns: repeat(auto-fit, 135px);
grid-gap:30px;
justify-content:space-between;

`

const Slider = ({ bags, onSelect, selected, imgRootPath }) => {
  return (
    <SliderContainer>
      {bags.map((bag, index) => (
        <Options
          key={index}
          imgRootPath={imgRootPath}
          modelName={bag.modelName}
          dimensions={bag.dimensions}
          options={bag.options}
          isSelected={selected === index}
          onImageClick={src => onSelect(index, src)}
        />
      ))}
    </SliderContainer>
  )
}

Slider.propTypes = {
  bags: arrayOf(shape(BagPropTypes)).isRequired,
  selected: number,
  onSelect: func,
  imgRootPath: string.isRequired,
}

export default Slider
